// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mOOuZfj0Tb0mv6qZIolx{padding:40px 0 24px;display:flex;flex-direction:column;gap:8px;min-width:492px}.Kqe8O9ZezAxcB4Dt2Xng{padding:0;min-width:0}`, "",{"version":3,"sources":["webpack://./src/pages/settings/ui/HowAddInboxNumberCards/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,mBAAA,CACA,YAAA,CACA,qBAAA,CACA,OAAA,CACA,eAAA,CAGF,sBACE,SAAA,CACA,WAAA","sourcesContent":[".content {\n  padding: 40px 0 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 492px;\n}\n\n.modalMode {\n  padding: 0;\n  min-width: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `mOOuZfj0Tb0mv6qZIolx`,
	"modalMode": `Kqe8O9ZezAxcB4Dt2Xng`
};
export default ___CSS_LOADER_EXPORT___;
